import { Injectable, inject } from '@angular/core';
import AngularHelperService from '../services/angular-helper.service';

@Injectable({ providedIn: 'root' })
export default class HttpHelper {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	executeHttp(httpPromise, successCallback, errorCallback) {
		if (successCallback) {
			httpPromise.subscribe(
				(response) => {
					successCallback(response)
				},
				(err) => {
					console.log(err);
					if (err.status == 511 && !this.angularHelperService.isPublicPath()) {
						window.location.href = window.location.origin;
					} else {
						errorCallback(err);
					}
				}
			);
		} else {
			return this.wrapResponsePromise(httpPromise);
		}
	}

	wrapResponsePromise(wrapped) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		wrapped.subscribe(
			(response) => {
				deferred.resolve(response);
			},
			(response) => {
				console.log(response);
				if (response.status == 511 && !this.angularHelperService.isPublicPath()) {
					window.location.href = window.location.origin;
				} else {
					deferred.reject(response);
				}
			}
		);
		return deferred.promise;
	}

}